
export const getBucketUrlForEpisode = (podcastId: string, episodeId: string) => {
    let suffix = `/${podcastId}/${episodeId}`
    return "http://chapters.hypercatcher.com" + suffix
}